<script setup>
import { sendStudyFormToServer } from "~/services/emailSendingServices"

const config = useNuxtApp().$config

const fullName = ref("")
const phoneNumber = ref("")
const furtherInfo = ref("")

const { $swal } = useNuxtApp()

// GTAG und FB Pixel
useHead({
  script: [{ src: "/scripts/meta-pixel.js" }],
})

async function avoidFormSubmitAndPost(e) {
  e.preventDefault()
  const res = await sendStudyFormToServer(
    config.public.backendBaseUrl,
    fullName.value,
    phoneNumber.value,
    furtherInfo.value
  )
  console.log(res)
  if (res === false) {
    alertFailure()
  } else {
    alertSuccess()
  }
}

function alertFailure() {
  $swal.fire({
    title: "Ein Fehler ist aufgetreten",
    text: "Das tut uns leid! Bitten Sie es noch einmal oder schreiben Sie uns eine E-Mail an: support@memodio-app.com!",
    icon: "error",
    confirmButtonText: "Verstanden",
  })
}

function alertSuccess() {
  $swal.fire({
    title: "Wir haben Ihre Nachricht erhalten",
    text: "Vielen Dank! Wir haben Ihre Nachricht erhalten und werden uns zeitnah mit Ihnen in Verbindung setzen. Prüfen Sie gerne noch einmal, ob Sie die korrekte Nummer angegeben haben!",
    icon: "success",
    confirmButtonText: "Zurück",
  })
}
</script>

<template>
  <div class="container column">
    <div class="title is-size-2 is-size-3-mobile">Wunderbar! Sie scheinen sich für die Studie zu eignen</div>
    <div>
      Bitte teilen Sie uns Ihre Kontaktdaten mit, um Sie für die weitere Koordination kontaktieren zu können. Mit
      klicken auf "Absenden", stimmen Sie unseren
      <a href="/datenschutz" target="_blank">Datenschutzbestimmung</a> zu. Sie verpflichten sich hiermit noch zu keiner
      Teilnahme.
    </div>
    <div class="study-form">
      <form class="form-horizontal" @submit.prevent="avoidFormSubmitAndPost">
        <fieldset>
          <legend></legend>
          <div class="field">
            <label class="label" for="textinput-0">Vor- und Nachname*</label>
            <div class="control">
              <input
                id="textinput-0"
                v-model="fullName"
                name="textinput-0"
                type="text"
                placeholder="Max Mustermann"
                class="input"
                required
              />
            </div>
          </div>

          <div class="field">
            <label class="label" for="textinput-1">Telefonnummer* (unter der Sie erreichbar sind)</label>
            <div class="control">
              <input
                id="textinput-1"
                v-model="phoneNumber"
                name="textinput-1"
                type="text"
                placeholder="03123 1236789"
                class="input"
                required
              />
            </div>
          </div>

          <div class="field">
            <label class="label" for="textarea-0">Weitere Hinweise an uns (optional)</label>
            <div class="control">
              <textarea id="textarea-0" v-model="furtherInfo" class="textarea" name="textarea-0"></textarea>
            </div>
          </div>
          <div class="is-flex is-justify-content-end">
            <button class="button is-size-5 is-brandpurple is-rounded">Abschicken</button>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<style scoped lang="scss">
.study-form {
  width: 60%;
  margin: 2rem auto;

  @media (max-width: $tablet) {
    width: 96%;
  }
}
</style>
